export default "__VITE_ASSET__DjIPhyHU__"